import { CIAN_PRO_RS_KEY } from './cianProExperiment';

export const DEAL_RENT_MENU_LINK = 'deal_rent_menu_item_title_experiment';
export const DEAL_RENT_MENU_ITEM_RENAME = 'deal_rent_header_menu_item_rename';
export const DEAL_RENT_HEADER_BANNER = 'deal_rent_header_banner';
export const DEAL_RENT_HEADER_NEW_ITEM = 'deal_rent_head_new_item';
export const AUTH_BY_PHONE_FIRST_EXPERIMENT = 'auth_by_phone_first';

export const STATIC_EXPERIMENTS = [
  DEAL_RENT_MENU_LINK,
  DEAL_RENT_HEADER_BANNER,
  DEAL_RENT_HEADER_NEW_ITEM,
  DEAL_RENT_MENU_ITEM_RENAME,
  AUTH_BY_PHONE_FIRST_EXPERIMENT,
];

/**
 * Имя данных экспериментов можно поменять в runtime settings.
 * Требуется, если возможны изменения в эксперименте, которые не позволяет сделать админка ab-use.
 * Например, если нужно повысить процент контрольной группы, либо поменять количество групп =>
 * отключаем старый эксперимент, создаем новый.
 */
export const DYNAMIC_EXPERIMENTS = [CIAN_PRO_RS_KEY];
